

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CustomChip from "./CustomChip.js"

const Jobs = () => (
    <div className="mt-5 mb-5">
        <p className="text-white text-[17px] font-semibold"> Experiencia Laboral </p>
        <ol className="relative border-s-[2px] border-gris mt-4" >
            <li className="mb-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Subdirector de Integración y mapeo </p>
                            <p className="text-white text-sm font-semibold">Secretaría de Gobernación – CNB (Comisión Nacional de Búsqueda de PersonasDesaparecidas)</p>
                        </div>
                        <p className="text-main text-xs font-semibold"> Octubre 2024 - Actualmente </p>
                    </div>
                    
                    <p className="text-main text-sm text-justify mt-1"> 
                        He liderado el desarrollo de aplicaciones web con tecnologías como PHP, VueJS, React y Node, participando en todas 
                        las fases del ciclo de vida del proyecto. También he implementado y orquestado soluciones 
                        en entornos Linux mediante Docker y Kubernetes, asegurando entornos escalables y altamente disponibles. 
                        Además, he formado parte de juntas de planeación y seguimiento para coordinar proyectos estratégicos y 
                        he supervisado acciones para optimizar la búsqueda en campo de personas desaparecidas, 
                        garantizando el uso eficiente de los sistemas informáticos disponibles.
                    </p>

                    <div className="flex flex-wrap gap-[6px] mt-3">
                        <CustomChip label="Vue" />
                        <CustomChip label="Node" />
                        <CustomChip label="PHP" />
                        <CustomChip label="React" />
                        <CustomChip label="Angular" />
                        <CustomChip label=".NET" />
                        <CustomChip label="Debian" />
                        <CustomChip label="Dockers" />
                        <CustomChip label="Git" />
                    </div>
                </div>
            </li>


            <li className="ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                    
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold"> Jefatura de Departamento</p>
                            <p className="text-white text-sm font-semibold"> Secretaría de Gobernación – CNB (Comisión Nacional de Búsqueda de Personas Desaparecidas)</p>
                        </div>
                        <p className="text-main text-xs font-semibold"> Marzo 2024 – Septiembre 2024 </p>
                    </div>

                    <p className="text-main text-sm text-justify mt-1"> 
                        Desarrollo de aplicaciones web con PHP, VueJS y Node, aplicando principios de clean code, arquitecturas desacopladas 
                        como MVC y microservicios, metodologías ágiles, e integrando APIs y servicios externos, apoyado 
                        por herramientas como Git para una gestión colaborativa y eficiente del código. 
                    </p>


                    <div className="flex flex-wrap gap-[6px] mt-3">
                        <CustomChip label="Vue" />
                        <CustomChip label="Node" />
                        <CustomChip label="PHP" />
                        <CustomChip label="Debian" />
                        <CustomChip label="Git" />
                    </div>

                </div>
            </li>


            <li className="mt-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">

                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Mid-Developer en aplicaciones móviles y web</p>
                            <p className="text-white text-sm font-semibold"> Strappberry Mobile App & Software Development  </p>
                        </div>
                        <p className="text-main text-xs font-semibold"> Marzo 2023 – Febrero 2024 </p>
                    </div>
                    
                    <p className="text-main text-sm text-justify mt-1"> 
                        Desarrollo y optimización de aplicaciones móviles con React Native y aplicaciones web con React y Laravel, 
                        integrando APIs RESTful y SOAP,  autenticación OAuth2 y notificaciones push con FCM. 
                        Participación en revisiones de código, pruebas unitarias y solución de errores, 
                        garantizando entregas puntuales y de calidad.
                    </p>
                    <div className="flex flex-wrap gap-[6px] mt-3">
                        <CustomChip label="React" />
                        <CustomChip label="React Native" />
                        <CustomChip label="PHP" />
                        <CustomChip label="Laravel" />
                        <CustomChip label="Livewire" />
                        <CustomChip label="Spring Boot" />
                        <CustomChip label="Flutter" />
                        <CustomChip label="Phyton" />
                        <CustomChip label="FireBase" />
                        <CustomChip label="Digital Ocean" />
                    </div>
                </div>
            </li>


            <li className="mt-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                    
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Programador Junior.</p>
                            <p className="text-white text-sm font-semibold">“Habilee” S.A De. C.V - Professional English Services</p>
                        </div>
                        <p className="text-main text-xs font-semibold"> Junio 2022 – Marzo 2024 </p>
                    </div>
                     
                    <p className="text-main text-sm text-justify mt-1"> 
                        Desarrollo de una plataforma web para evaluación de idiomas, con frontend responsivo en 
                        ReactJS y backend en Node.js + MongoDB. Implementación de API RESTful para 
                        gestión eficiente de datos y soporte en tiempo real para usuarios concurrentes.
                    </p>
                    <div className="flex flex-wrap gap-[6px] mt-3">
                        <CustomChip label="React" />
                        <CustomChip label="Node" />
                        <CustomChip label="MongoDB" />
                    </div>
                </div>
            </li>


            <li className="mt-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                    
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Programador.</p>
                            <p className="text-white text-sm font-semibold">Subsecretaria de Educación Superior (Estancias Profesionales)</p>
                        </div>
                        <p className="text-main text-xs font-semibold">Enero 2023 – Junio 2024</p>
                    </div>

                    <p className="text-main text-sm text-justify mt-1"> 
                        Creación de un sistema web para la Secretaría de Educación Pública (SEP)
                        llamado RENOES (Registro Nacional de Opciones para Educación Superior),
                        diseñado para proporcionar a los aspirantes de educación superior
                        información detallada y accesible sobre las diversas carreras y programas
                        educativos ofrecidos a nivel nacional por diversas universidades nacionales.
                    </p>
                    <div className="flex flex-wrap gap-[6px] mt-3">
                        <CustomChip label="React" />
                        <CustomChip label="PHP" />
                        <CustomChip label="Laravel" />
                        <CustomChip label="CentOS" />
                    </div>
                </div>
            </li>

            
            <li className="mt-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs bg-gris_alt border-gray-600">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">Programador Junior.</p>
                            <p className="text-white text-sm font-semibold">Desarrollos Tecnológicos y Estratégicos MOEM "Nibiru System"</p>
                        </div>
                        <p className="text-main text-xs font-semibold">Agosto 2019 – Diciembre 2021 </p>
                    </div>
    
                    <p className="text-main text-sm text-justify mt-1"> 
                        Especializado en aplicaciones de escritorio (C#, Java) y móviles (React Native). 
                        Experiencia en diseño de interfaces, 
                        optimización de rendimiento y desarrollo de bases de datos (SQL Server, MySQL). 
                        Habilidades en mantenimiento, depuración y mejora de sistemas.
                    </p>
                    <div className="flex flex-wrap gap-[6px] mt-3">
                        <CustomChip label="React" />
                        <CustomChip label="C#" />
                        <CustomChip label=".NET" />
                        <CustomChip label="Java" />
                    </div>
                </div>
            </li>


            <li className="mt-10 ms-6">
                <span className="absolute flex items-center justify-center w-6 h-6  rounded-full -start-3 ring-8 ring-gris bg-negro_alt">
                    <BusinessCenterIcon className="text-amarillo" sx={{ fontSize: 14 }} />
                </span>
                <div className="p-4 rounded-lg shadow-xs  bg-gris_alt border-gray-600">
                    
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-white text-md font-semibold">H. Ayuntamiento de Acapulco.</p>
                            <p className="text-white text-sm font-semibold">Auxiliar Administrativo.</p>
                        </div>
                        <p className="text-main text-xs font-semibold">Abril 2023 – Septiembre 2024</p>
                    </div>
   
                    <p className="text-main text-sm text-justify mt-1"> 
                        Responsable de la actualización y organización de información crítica, 
                        garantizando precisión y disponibilidad de datos. Gestioné comunicación telefónica y correspondencia, 
                        manteniendo interacciones fluidas con áreas internas y externas.
                    </p>
                </div>
            </li>




            
        </ol>
    </div>
);

export default Jobs;
